import { parseCanonicalIcd10Code } from "@smartmed/codes";
import { pairedCodeWarnings } from "@smartmed/diagnosis-rules";

import type { EncounterSpecialty } from "@/api/encounters";

export const pairedCodeWarningsFor = (specialty: EncounterSpecialty | null | undefined, codes: readonly string[]) =>
  pairedCodeWarnings(codes.map(parseCanonicalIcd10Code), specialty);
